import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  buttonAlterPic: {

    paddingHorizontal: pixelDimensions(6),
    marginVertical: pixelDimensions(2),
    paddingVertical: pixelDimensions(2),
  },
  buttonBack: {
    alignSelf: 'flex-end',

    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
  content: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  imageChangePicBigger: {
    backgroundColor: 'white',
    height: pixelDimensions(50),
    width: pixelDimensions(50) * (100 / 97),
    resizeMode: 'contain',

  },
  textBack: {
    color: Colors.white,
    fontSize: pixelDimensions(4.5),
  },
  textButtonAlterPic: {
    textAlign: 'center',
    color: Colors.white,
    fontSize: pixelDimensions(5),
  },
  viewBase: {
    flex: 1,
    backgroundColor: Colors.grey300,
  },
});

export default styles;
